import React from 'react';
import DashboardPageContent from "../components/dashboardPageContent";

const Dashboard = () =>{
    return(
        <DashboardPageContent/>
    );
}

export default Dashboard;